import Header from "../components/Header";
import Footer from "../components/Footer";
import React, { useRef } from 'react';
import axios from 'axios';

const FailPayment = () => {
        return (
        <React.Fragment>
            <Header name={{ name: 'Welcome to React' }} />
            <div class="contentswrap">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="breadcrumb-wrap reg">
                                <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb">
                                    <br></br>
                                    <br></br>
                                        <li class="breadcrumb-item active">Step 3</li>
                                        <li class="breadcrumb-item" aria-current="page"> Transaction Failed</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                        <div class="form-wrap-titles">
                            <a href="" target="_blank"><img src="assets/img/fail.jpg" alt="" style={{fill:'#28d006',padding:'center',width:"90px",height:"90px"}}></img></a>
                            
                        </div>
                        <div class="form-wrap-titles">
                        <h1>Transaction Failed</h1>
                            <p>Your transaction was not successful.</p>
                        </div>
                    </div>
                    <div class="row">
                    </div>
                </div>
            </div>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <Footer />
        </React.Fragment>
    );
}

export default FailPayment;
